import Text from "../../../../components/ui/Text";
import { useTalkieWalkie } from "../../hooks/use-talkie-walkie";
import Button from "../ui/Button";
import { DateInput } from "../ui/DateInput";
import SlideInput from "../ui/SlideInput";

interface Props {
  className?: string;
  firstLabel?: string;
  secondLabel?: string;
  thirdLabel?: string;
  firstButtonTitle?: string;
  secondButtonTitle?: string;
  onFirstButtonClick?: () => void;
  onSecondButtonClick?: () => void;
}

const WalkieTalkieSettings = ({
  className = "",
  firstLabel = "Expiration Date of Freq",
  secondLabel = "Players Management",
  thirdLabel = "Logs Management",
  firstButtonTitle = "Add or Remove Players",
  secondButtonTitle = "View logs",
  onFirstButtonClick = () => {},
  onSecondButtonClick = () => {},
}: Props) => {
  const { setActiveScreen } = useTalkieWalkie();

  return (
    <div
      className={`space-y-3 mt-3 h-full overflow-y-scroll scrollbar-hide pb-[50px]  ${className}`}
    >
      {/** Slide input */}
      <div>
        <SlideInput
          value={25}
          onChange={() => {}}
          max={100}
          min={1}
          showPercentage
        />
      </div>

      {/** Date input */}
      <div>
        <Text size="xs" className="text-[#BEB9FF] mb-1">
          {firstLabel}
        </Text>
        <DateInput value={new Date()} />
      </div>

      {/** Players */}
      <div>
        <Text size="xs" className="text-[#BEB9FF] mb-1">
          {secondLabel}
        </Text>
        <Button
          variant="gray"
          onClick={() => {
            onFirstButtonClick();
            setActiveScreen("players");
          }}
        >
          <Text className="text-white/70 text-center" size="xxs">
            {firstButtonTitle}
          </Text>
        </Button>
      </div>

      {/** Logs */}
      <div>
        <Text size="xs" className="text-[#BEB9FF] mb-1">
          {thirdLabel}
        </Text>
        <Button
          variant="gray"
          onClick={() => {
            onSecondButtonClick();

            setActiveScreen("logs");
          }}
        >
          <Text className="text-white/70 text-center" size="xxs">
            {secondButtonTitle}
          </Text>
        </Button>
      </div>
    </div>
  );
};

export default WalkieTalkieSettings;
